<template>
    <div class="fixed w-full h-full inset-0 bg-black/35 flex justify-center items-center z-50 px-5">
        <div
            class="relative lg:w-1/4 w-5/6 h-fit flex flex-col justify-center p-5 items-center space-y-5 bg-white   rounded-xl">

            <div v-if="showLoadingPasswordVerificationModal"
                class="absolute w-full h-full bg-black/20 flex justify-center items-center z-50 rounded-xl">
                <div class="flex justify-center space-x-2 mt-3">
                    <span class="w-3 h-3 bg-white shadow-lg rounded-full animate-bounce-wave delay-0"></span>
                    <span class="w-3 h-3 bg-white shadow-lg rounded-full animate-bounce-wave delay-150"></span>
                    <span class="w-3 h-3 bg-white shadow-lg rounded-full animate-bounce-wave delay-300"></span>
                </div>
            </div>

            <div class="w-full flex flex-col justify-start items-center space-y-2"
                :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
                <div class="text-base font-medium lg:text-xl w-full lg:mb-2 text-gray-700">{{
                    $t('admin_edit.modal_password_title') }}</div>
                <div class="text-sm lg:text-base w-full lg:mb-2 text-gray-700">{{
                    $t('admin_edit.modal_password_sub') }}</div>
            </div>
            <div class="w-full">

                <input type="password" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'" v-model="form.password"
                    :class="inputClass(passwordError.error)" :placeholder="$t('admin_edit.currentPassword')" />
                <p v-if="passwordError.error" class="text-sm text-red-500 mt-1">
                    {{ $t('admin.errors.password_invalid') }}
                </p>
            </div>
            <div class="w-full flex lg:justify-end justify-center items-center space-x-3">
                <div @click="cancel"
                    class="px-3 py-2 text-gray-700 rounded-lg bg-gray-300 w-full text-center lg:w-fit mt-4 lg:mt-0 hover:cursor-pointer hover:scale-105 transition duration-200">
                    {{ $t('admin_edit.cancel') }}</div>
                <div @click="submitEdit"
                    class="px-3 py-2 text-white rounded-lg bg-primary w-full text-center lg:w-fit mt-4 lg:mt-0 hover:cursor-pointer hover:scale-105 transition duration-200">
                    {{ $t('admin_edit.validate') }}</div>

            </div>

        </div>
    </div>

</template>

<script setup>
import { updateAccountData } from '@/api/admin';
import { ref, defineProps, defineEmits, onMounted } from 'vue';


const props = defineProps({
    editForm: {
        type: Object,
        required: true
    }
});


const emit = defineEmits(['successEdit', 'cancelEdit', 'errorEdit']);


const form = ref({
    email: '',
    phone: '',
    newPassword: '',
    password: null,
})


onMounted(() => {
    form.value.email = props.editForm.email;
    form.value.phone = props.editForm.phone;
    form.value.newPassword = props.editForm.newPassword;
});

const passwordError = ref({
    error: false,
    message: ""
});

const showLoadingPasswordVerificationModal = ref(false);
const inputClass = hasError =>
    (hasError ? 'border border-red-400 ' : 'border border-primary ') +
    ' transition duration-200 outline-none w-full rounded px-3 py-2 text-sm lg:text-base'



const submitEdit = async () => {

    showLoadingPasswordVerificationModal.value = true;
    let response = null
    try {
        response = await updateAccountData(form.value);
        console.log('response :>> ', response);
        showLoadingPasswordVerificationModal.value = false;
        emit('successEdit');

    } catch (error) {

        showLoadingPasswordVerificationModal.value = false;
        passwordError.value.message = "errorUpdatingAdminInfo";
        let errors = error.response.data.errors;

        console.log('error :>> ', error);
        console.log('errors :>> ', errors);

        if (Array.isArray(errors) && errors.includes("passwordInvalid")) {
            passwordError.value.error = true;
            passwordError.value.message = "errorUpdatingAdminInfo";
        }


        emit('errorEdit', errors);

    }

}


const cancel = () => {
    emit('cancelEdit');
}
</script>

<style scoped>
@keyframes bounce-wave {

    0%,
    80%,
    100% {
        transform: translateY(0);
    }

    40% {
        transform: translateY(-8px);
    }
}

.animate-bounce-wave {
    animation: bounce-wave 1.2s infinite ease-in-out;
}

.delay-0 {
    animation-delay: 0s;
}

.delay-150 {
    animation-delay: 0.15s;
}

.delay-300 {
    animation-delay: 0.3s;
}

/* Remove arrows for Chrome, Safari, Edge, and Opera */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Remove arrows for Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}
</style>